import React from "react";

function ClickableIcon({ icon: Icon, ...rest }) {
  return <Icon style={{ cursor: "pointer" }} {...rest} />;
}

export default ClickableIcon;
